"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Metrics = function Metrics(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.248 9.276h-2.532c-.204 0-.388.076-.548.18V5.688c0-.564-.46-1.024-1.024-1.024H8.612c-.564 0-1.024.46-1.024 1.024v2.176a.996.996 0 00-.548-.18H4.508c-.564 0-1.024.46-1.024 1.024v5.604c0 .564.46 1.024 1.024 1.024H7.04c.324 0 .6-.16.788-.392.188.232.464.392.788.392h2.532c.324 0 .6-.16.788-.392.188.232.464.392.788.392h2.532c.564 0 1.024-.46 1.024-1.024V10.3a1.033 1.033 0 00-1.032-1.024zm-8.104 5.036c0 .06-.048.108-.108.108H4.504a.108.108 0 01-.108-.108V8.708c0-.06.048-.108.108-.108h2.532c.06 0 .108.048.108.108v5.604zm4.104 0c0 .06-.048.108-.108.108H8.608a.108.108 0 01-.108-.108V5.688c0-.06.048-.108.108-.108h2.532c.06 0 .108.048.108.108v8.624zm4.108 0c0 .06-.048.108-.108.108h-2.532a.108.108 0 01-.108-.108V10.3c0-.06.048-.108.108-.108h2.532c.06 0 .108.048.108.108v4.012z",
    fill: color
  }));
};
var _default = exports["default"] = Metrics;